/**
 * Created by mark on 17/12/2017.
 */

import BaseStore from './base-store.js';
import Constants from '../constants.js';

var _registerToActions = function(action){

    switch(action.actionType)
    {
        case Constants.CUSTOM_MODULES:
            this.customModules = action.response.modules || [];

            this.customModules = this.customModules.map(function(module){
                return {
                    module:module
                }
            });

            this.emit(Constants.CUSTOM_MODULES);
            break;
        case Constants.GET_ALL_MODULE_IDS:
            this.vocabModules = action.response || [];
            this.emit(Constants.GET_ALL_MODULE_IDS);
            break;
        case Constants.GET_ALL_VERB_IDS:
            this.verbModules = action.response || [];
            this.emit(Constants.GET_ALL_VERB_IDS);
            break;
        case Constants.GET_ALL_VOCAB_GAMES:
            this.vocabGames = action.response.gameResults || [];
            this.emit(Constants.GET_ALL_VOCAB_GAMES);
            break;
        case Constants.GET_ALL_VERB_GAMES:
            this.verbGames = action.response || [];
            this.emit(Constants.GET_ALL_VERB_GAMES);
            break;
        case Constants.GET_ALL_SENTENCEBUILDING_IDS:
            this.sentenceModules = action.response.modules || [];
            this.emit(Constants.GET_ALL_SENTENCEBUILDING_IDS);
            break;
        case Constants.GET_ALL_GRAMMAR_IDS:
            this.grammarModules = action.response.modules || [];
            this.emit(Constants.GET_ALL_GRAMMAR_IDS);
            break;
        case Constants.GET_ALL_SENTENCE_GAMES:
            this.sentenceGames = action.response.gameResults || [];
            this.emit(Constants.GET_ALL_SENTENCE_GAMES);
            break;
}

};

class ContentStore extends BaseStore{

    constructor(){
        super();
        this.subscribe(() => _registerToActions.bind(this));
        this.vocabModules = [];
        this.verbModules = [];
        this.gameResults = [];
        this.sentenceModules = [];
        this.grammarModules = [];
        this.gameResults = [];
    }

    getVocabModules(){
        return this.vocabModules || [];
    }

    setVocabModules(vocabModules){
        this.vocabModules = vocabModules;
    }

    getVerbModules(){
        return this.verbModules || [];
    }

    setVerbModules(verbModules){
        this.verbModules = verbModules;
    }
}

export default new ContentStore();